import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'
import { encrypt, decrypt } from '@utils/local-storage'
import store from '@state/store'
import jwt_decode from "jwt-decode"

let _moment = require('moment')

let serverUrl = getSecret('SERVER_MASTER_URL')
let serverPollsUrl = getSecret('SERVER_FORMS_URL')

export const state = {
  polls_cached: {},
  sessions_cached: {},
}

export const getters = {
    polls_cached: state => {
    const polls_stored = getSavedState('polls_cached')
    if (Object.keys(state.polls_cached).length === 0 && Object.keys(polls_stored).length > 0){
      return polls_stored
    }
    return state.polls_cached
  },
  sessions_cached: state => {
    const sessions_stored = getSavedState('sessions_cached')
    if (Object.keys(state.sessions_cached).length === 0 && Object.keys(sessions_stored).length > 0){
      return sessions_stored
    }
    return state.sessions_cached
  }
}

export const mutations = {
  CACHE_POLLSMANAGERS(state, polls) {
    saveState('polls_cached', polls);
    state.polls_cached = polls
  },
  CACHE_POLLSESSIONS(state, session) {
    let sessions_stored = getSavedState("sessions_cached");
    let finded = false
    if (session.hasOwnProperty('key')){
      sessions_stored.forEach((item, index)=> {
        if (item.key === session.key){
          sessions_stored[index] = session
          finded = true
        }
      })
    } 
    if (!finded){
      sessions_stored.push(session);
    }
    saveState('sessions_cached', sessions_stored);
    state.sessions_cached = sessions_stored
  },
}

export const actions = {
  getSecretaries(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/api/secretarities/${query}`).then((response) => {
      return response.data
    })
  },

  getIndicators(context, query, id) {
    query = query || ''
    
    return axios.get(`${serverUrl}/api/secretariatindicators/${(id ? id + '/' : '')}${query}`).then((response) => {
      return response.data
    })
  },

  getProjects(context, query, id) {
    query = query || ''
    
    return axios.get(`${serverUrl}/api/secretariatprojects/${(id ? id + '/' : '')}${query}`).then((response) => {
      return response.data
    })
  },

  getCommunes(context, query, id) {
    query = query || ''
    
    return axios.get(`${serverUrl}/api/communes/${(id ? id + '/' : '')}${query}`).then((response) => {
      return response.data
    })
  },

  getNeighborhoods(context, query, id) {
    query = query || ''
    
    return axios.get(`${serverUrl}/api/neighborhoods/${(id ? id + '/' : '')}${query}`).then((response) => {
      return response.data
    })
  },
  getTokenForPoll(context,poll){
    return axios.post(`${serverUrl}/api/polls/${poll.id}/get_token_poll/`,{}).then((response) => {
      return response.data
    })
  },
  getPolls(context, payload) {
    let params = payload || {}
    let pollId
    let query
    if (Object(params).hasOwnProperty('pollId')){
      pollId = params.pollId + '/'
      query = params.query || ''
    } else {
      pollId = ''
      query = payload.query || ''
    }
    return axios.get(`${serverUrl}/api/polls/${pollId}${query}`).then((response) => {
      return response.data
    })
  },
  deletePoll(context,poll) {
    let promise = null
    promise = axios.delete(`${serverUrl}/api/polls/${poll.id}/?validation=${poll.validate}`)
    return promise.then((response) => {
      return response.data
    })
  },

  getPollsManaged({ commit } , query) {
    query = query || ''
    query += "&user_id=" + getCurrentSessionUser().user.id
    return axios
      .get(`${serverUrl}/api/pollsmanagers/${query}`)
      .then((response) => {
        commit('CACHE_POLLSMANAGERS', response.data)
        return response.data
      })
      .catch((err) => {
        store.dispatch('utils/message', {
          type: 'error',
          title: 'Error',
          text: 'Error consultando Encuestas',
        })
        return err.response
      })
  },
  getPollsManagedById({ commit } , query) {
    query = query || ''
    query += "&user_id=" + getCurrentSessionUser().user.id
    return axios
      .get(`${serverUrl}/api/pollsmanagers/${query}`)
      .then((response) => {
        // commit('CACHE_POLLSMANAGERS', response.data)
        return response.data
      })
      .catch((err) => {
        store.dispatch('utils/message', {
          type: 'error',
          title: 'Error',
          text: 'Error consultando el Encuestas',
        })
        return err.response
      })
  },

  getPollsManagedNoToken({ commit } , data) {
    data.query = data.query || ''
    let decoded = jwt_decode(data.token);
    data.query += `&user_id=${decoded.user_id}`
    return axios
      .get(`${serverUrl}/api/pollsmanagers/${data.query}`, {
        headers: {
          'Authorization': `key ${data.token}`
        }
      })
      .then((response) => {
        return response.data
      })
      .catch((err) => {
        store.dispatch('utils/message', {
          type: 'error',
          title: 'Error',
          text: 'Error consultando Encuestas',
        })
        return err.response
      })
  },

  createPollsManaged({ commit} , pollData) {
    let promise = null
    if (pollData.id !== null){
      promise = axios.put(`${serverUrl}/api/pollsmanagers/${pollData.poll}/`, pollData)
    } else {
      promise = axios.post(`${serverUrl}/api/pollsmanagers/`, pollData)
    }
    return promise.then((response) => {
      return response.data
    })
  },

  getBaseVariables() {
    return axios.get(`${serverUrl}/api/variables/`).then((response) => {
      return response.data
    })
  },

  getCountQueueSessions(context, pollId  ){
    const sessions_stored = getSavedState("sessions_cached");
    if (pollId !== null){
      return sessions_stored.filter((x) => x.poll == pollId).length
    }
    return sessions_stored.length
  },


  setPollSession({commit} , data){
    if (!data.hasOwnProperty('key')){
      Object.assign(data, {key: Date.now() })
    }
    if (data.hasOwnProperty('start_time')){
      if(!data.hasOwnProperty('end_time')){
        Object.assign(data, {end_time: _moment(new Date()).format('YYYY-MM-DDTHH:mm:ssZ') })
      }
    } else {
      Object.assign(data, {start_time: _moment(new Date()).format('YYYY-MM-DDTHH:mm:ssZ') })
    }

    if (!window.navigator.onLine){
      if (data.mode === 'record'){
        commit('CACHE_POLLSESSIONS', data)
      } // else mode: 'sync'
      const sessions_stored = getSavedState("sessions_cached");
      return { id: null, key: data.key, queue_sessions: sessions_stored.length, start_time: data.start_time }
    } else {
      let promise = null
      if (data.hasOwnProperty('id') && data.id !== null){
        const payload = {
          poll: data.poll,
          key: data.key || Date.now(),
          id: data.id, 
          state: 'F',
          detail: data.dimensions,
          end_time: data.end_time ? data.end_time : null
        }
        promise = axios.put(`${serverPollsUrl}/api/filloutpoll/${payload.id}/`, payload)
      } else {
        promise = axios.post(`${serverPollsUrl}/api/filloutpoll/`, {
          poll: data.poll,
          poll_manager: data.poll_manager,
          key: data.key || Date.now(), 
          state: data.end_time ? 'F' : 'C',
          detail: data.dimensions,
          start_time: data.start_time,
          end_time: data.end_time ? data.end_time : null
        })
      }
      return promise.then((response) => {
        if (Object(response.data).hasOwnProperty('id')){
          // remove from localStorage:
          removeFromStorage("sessions_cached", response.data.key)
          const sessions_stored = getSavedState("sessions_cached");
          response.data['queue_sessions'] = sessions_stored.length
          return response.data
        } else {
          let errors = ""
          response.errors.forEach((x, i) => {
            errors += `${i} - ${x}`
          })
          store.dispatch('utils/message', {
            type: 'error',
            title: 'Errores al guardar Encuestas',
            text: errors,
          })
        }
      })
    }
  },
  setPollWithToken({ commit }, poll) {
    let data = poll.data
    if (!data.hasOwnProperty('key')) {
      Object.assign(data, { key: Date.now() })
    }
    if (data.hasOwnProperty('start_time')) {
      if (!data.hasOwnProperty('end_time')) {
        Object.assign(data, { end_time: _moment(new Date()).format('YYYY-MM-DDTHH:mm:ssZ') })
      }
    } else {
      Object.assign(data, { start_time: _moment(new Date()).format('YYYY-MM-DDTHH:mm:ssZ') })
    }

    let promise = null
    promise = axios.post(`${serverPollsUrl}/api/filloutpoll/save_poll/?token=${poll.token}`, {
        poll: data.poll,
        key: data.key || Date.now(),
        state: data.end_time ? 'F' : 'C',
        detail: data.dimensions,
        start_time: data.start_time,
        end_time: data.end_time ? data.end_time : null
    })
    return promise.then((response) => {
      if (Object(response.data).hasOwnProperty('id')) {
        return response.data
      } else {
        store.dispatch('utils/message', {
          type: 'error',
          title: 'Errores al guardar la Encuesta',
        })
      }
    })

  },
  
  getPollsession(context, data){
    // NOTA: Esto, por si solicitaran habilitar edición de formulario diligenciado (no se ha completado)
    return data
  },

  getPollsessions(context, poll_id){
    // TODO: Este es el reporte temporal (básico). El completo se conectaría al servidor de reportes.
    let user_id = getCurrentSessionUser().user.username || ''
    return axios.get(`${serverPollsUrl}/api/filloutpoll/?poll_id=${poll_id}&meta__created_by=${user_id}`).then((response) => {
      return response.data
    })
  },
  getPollswithToken(context,data){
    return axios.get(`${serverUrl}/api/polls/validate_token_poll/?token=${data.token}`).then((response) => {
      return response.data
    })
    
  },
  createPoll(context, pollData) {
    // console.log('esto es la data enviada', formData)
    let promise = null
    if (pollData.id !== null){
    
      promise = axios.put(`${serverUrl}/api/polls/${pollData.id}/`, pollData)
    } else {
      promise = axios.post(`${serverUrl}/api/polls/`, pollData)
      
    }
    return promise.then((response) => {
      return response.data
    })
  },

  createPollVars(context, pollData) {
    // console.log("respuesta",pollData)
    
    // console.log('esto es la data enviada', formData)
    let promise = null
    if (pollData.poll){
      promise = axios.put(`${serverUrl}/api/pollsdimensions/${pollData.poll}/`, pollData)
    } else {
      promise = axios.post(`${serverUrl}/api/pollsdimensions/`, pollData)
    }
    return promise.then((response) => {
      return response.data
    })
  },
  setVariableFile(context, {pollData }) {
    let promise = null
    promise = axios.post(`${serverPollsUrl}/api/filloutpoll/set_file_variable/`, pollData, {
      headers: { 'Content-Type': 'multipart/poll-data' },
    })
    return promise.then((response) => {
      return response.data
    })
  },
  // getDimensionsPoll({ commit }, query = '') {
  //   query = query || ''
  //   return axios.get(`${serverUrl}/api/pollsdimensions/${query}`).then((response) => {
  //     commit('CACHE_DIMENSIONS', response.data)
  //     return response.data
  //   }).catch((err) => {
  //     store.dispatch('utils/message', {
  //       type: 'error',
  //       title: 'Error',
  //       text: 'Error consultando dimensiones',
  //     })
  //     return err.response
  //   })
  // },
}

// ===
// Private helpers
// ===

function getSavedState(key) {
  key = getCurrentSessionUser().user.username + '.' + key
  return getStateLocalStorage(key)
}
function saveState(key, state) {
  key = getCurrentSessionUser().user.username + '.' + key
  saveStateLocalStorage(key, state)
}

function removeFromStorage(key, item) {
  let records = getSavedState(key).filter((x) => { return String(x.key) !== String(item) })
  saveState(key, records)
}

function getCurrentSessionUser() {
  let user = getStateLocalStorage('auth.currentSession')
  if (user == null || user.length < 0) {
    user = JSON.parse('[{"user":{"username":"","id":0}}]')
  }
  return user
}

function getStateLocalStorage(key) {
  let storage = window.localStorage.getItem(key)
  if (storage != null) {
    if (typeof (storage) == Object && storage.length < 0) {
      return JSON.parse('[]')
    }
    return JSON.parse(decrypt(storage))
  } else {
    return JSON.parse('[]')
  }
}

function saveStateLocalStorage(key, state) {
  window.localStorage.setItem(key, encrypt(JSON.stringify(state)))
  // window.localStorage.setItem(key, (JSON.stringify(state)))
}

